import { Input, InputProps } from "features/common/components/Input";
import { useCallback } from "react";
import {
  Controller,
  ControllerRenderProps,
  Path,
  UseControllerProps,
} from "react-hook-form";
import type { FieldValues } from "react-hook-form/dist/types/fields";

export type FormInputProps<T extends FieldValues = FieldValues> = Omit<
  UseControllerProps<T>,
  "defaultValue"
> &
  InputProps;

export const FormInput = <T extends FieldValues = FieldValues>(
  props: FormInputProps<T>
) => {
  const {
    name,
    control,
    rules,
    onChange,
    label,
    fullWidth = true,
    ...restProps
  } = props;

  const handleChange = useCallback(
    (field: ControllerRenderProps<T, Path<T>>) => (value: any) => {
      field.onChange(value);
      onChange?.(value);
    },
    [onChange]
  );

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        const { ref, ...restPropsField } = field;

        return (
          <Input
            {...restPropsField}
            name={name}
            label={label}
            value={field.value}
            data-testid={name}
            fieldLength={field.value.length}
            onChange={handleChange(field)}
            error={error}
            {...restProps}
            fullWidth={fullWidth}
            autoComplete="off"
          />
        );
      }}
    />
  );
};
